module.exports = __webpack_public_path__ + "img/ck.ck95a6162.svg";